import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://newyys.dingyutx.com/prod-api', // 
  withCredentials: false, // 是否携带cookie信息，默认false
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export default apiClient;